import actions from "./auth.actions";
import { getClientCookie, setLoginCookies } from "../../lib/cookiesHelpers";

export const initialState = {
  user: {
    phone: getClientCookie("user_phone"),
    name: getClientCookie("user_name"),
    user_id: getClientCookie("user_id"),
    img: getClientCookie("user_img"),
    email: getClientCookie("user_email"),
    about: getClientCookie("user_about"),
    chosen_user_type: getClientCookie("user_chosen_user_type"),
    iam_verified: getClientCookie("user_iam_verified"),
    listings: getClientCookie("user_listings"),
    favs: getClientCookie("user_favs"),
    type: getClientCookie("user_type"),
    active_aqar_plus_user: getClientCookie("user_active_aqar_plus_user"),
    show_aqar_plus: getClientCookie("user_show_aqar_plus"),
    paid: getClientCookie("user_paid"),
    create_time: getClientCookie("user_create_time"),
  },
  token: getClientCookie("webapp_token"),
  userCards: [],
};

export default function authReducer(state, action) {
  if (action.type === actions.LOGIN) {
    return {
      ...state,
      user: action.payload.user,
      token: action.payload.token,
      userCards: [],
    };
  }

  if (action.type === actions.LOGOUT) {
    setLoginCookies("", {});
    return {
      ...state,
      user: {},
      token: "",
      userCards: [],
    };
  }

  if (action.type === actions.STORE_CARDS) {
    return {
      ...state,
      userCards: action.payload,
    };
  }

  return state;
}
